import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createCopilotPayloadToExecuteCommand, triggerFileManagerImageGeneration, handleTextReplacement } from 'tinymce-plugins/hsgenandselect/utils';
import { canUpdateSelection } from 'tinymce-plugins/hscopilotcollaboration/utils';
// @ ts-expect-error not migrated yet
import { updateAiFeaturesForMainContent } from 'EmailEditorUI/redux/actions/aiFeaturesActions';
import { getIsContentAssistanceEnabled } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export function previewCommandHandler(editor, command, commandType) {
  // Handle AI image gen command that doesn't go to copilot
  if ('id' in command && command.id === 'generateimage') {
    triggerFileManagerImageGeneration(editor);
    return;
  }
  const payload = createCopilotPayloadToExecuteCommand(editor, command, commandType);
  sendCommandToCopilotInContentEditorFromPreview(payload, editor);
}
function handleTextReplacementForInpage(editor, generatedText, dispatch) {
  handleTextReplacement(editor, generatedText);

  // Update the selection after inserting the text, as it will now be selected
  sendUpdateToCopilotInContentEditorFromPreview({
    hasFocus: true,
    hasSelection: true
  }, editor.settings.bus);
  dispatch(updateAiFeaturesForMainContent());
}
export function createFocusOrSelectionHandlerWithBus(bus) {
  return ({
    hasFocus,
    hasSelection
  }) => sendUpdateToCopilotInContentEditorFromPreview({
    hasFocus,
    hasSelection
  }, bus);
}
function sendCommandToCopilotInContentEditorFromPreview(payload, editor) {
  editor.settings.bus.postMessage({
    action: 'copilot:send-copilot-command',
    payload
  });
}
function sendUpdateToCopilotInContentEditorFromPreview({
  hasFocus,
  hasSelection
}, bus) {
  bus.postMessage({
    action: `copilot:update-tiny-mce-state`,
    payload: {
      hasFocus,
      hasSelection
    }
  });
}
function PreviewFrameCopilotCollabSessionManagerInternal() {
  const dispatch = useDispatch();
  useEffect(() => {
    const typedWindow = window;
    typedWindow.LayoutBuilderUI.messenger.setOnInsertRichText(message => {
      var _window$tinymce;
      // @ts-expect-error tinymce on window global
      const activeEditor = (_window$tinymce = window.tinymce) === null || _window$tinymce === void 0 ? void 0 : _window$tinymce.activeEditor;
      if (activeEditor && canUpdateSelection(activeEditor)) {
        handleTextReplacementForInpage(activeEditor, message.payload.text, dispatch);
      }
    });
    return () => {
      typedWindow.LayoutBuilderUI.messenger.setOnInsertRichText();
    };
  }, [dispatch]);
  return null;
}
function PreviewFrameCopilotCollabSessionManager() {
  const isCopilotEnabled = useSelector(getIsContentAssistanceEnabled);
  return isCopilotEnabled && /*#__PURE__*/_jsx(PreviewFrameCopilotCollabSessionManagerInternal, {});
}
export default PreviewFrameCopilotCollabSessionManager;